<template>
    <a-row :gutter="24">
        <a-col span="12">
            <a-textarea v-model:value="text" :rows="25" allow-clear></a-textarea>
        </a-col>
        <a-col span="12">
            <SimpleCode :data="text"></SimpleCode>
        </a-col>
    </a-row>
</template>

<script setup>
    import {ref} from 'vue';
    import SimpleCode from "../components/SimpleCode";
    const text = ref('');
</script>

<style scoped>

</style>